import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", phone: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(`Changing ${name} to ${value}`);
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form submitted with data:", formData);
    setIsSubmitting(true);

    const phoneRegex = /^\+?[1-9]\d{1,14}$/;
    if (!phoneRegex.test(formData.phone)) {
      alert("Please enter a valid phone number (e.g., +919876543210 or 9876543210).");
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch("/api/submit-contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.statusText}`);
      }

      console.log("Submission successful");
      setFormData({ name: "", phone: "", message: "" });
      navigate("/thank-you");
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("There was an error submitting your inquiry. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const containerStyle = {
    textAlign: "center",
    padding: "clamp(10px, 5vw, 20px)",
    maxWidth: "600px",
    margin: "0 auto",
  };

  const formStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
    width: "100%",
    maxWidth: "100%",
    textAlign: "left",
  };

  const inputStyle = {
    width: "100%",
    padding: "8px",
    boxSizing: "border-box",
    fontSize: "clamp(14px, 2.5vw, 16px)",
  };

  const textareaStyle = {
    width: "100%",
    padding: "8px",
    boxSizing: "border-box",
    fontSize: "clamp(14px, 2.5vw, 16px)",
    minHeight: "100px",
  };

  const buttonStyle = {
    padding: "clamp(8px, 2vw, 10px)",
    fontSize: "clamp(14px, 2.5vw, 16px)",
    backgroundColor: isSubmitting ? "#ccc" : "#007BFF",
    color: "white",
    border: "none",
    cursor: isSubmitting ? "not-allowed" : "pointer",
    width: "100%",
    maxWidth: "200px",
    margin: "0 auto",
  };

  return (
    <div style={containerStyle}>
      <h1>Contact Us</h1>
      <form onSubmit={handleSubmit} style={formStyle}>
        <label>Name:</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          disabled={isSubmitting}
          style={inputStyle}
        />
        <label>Phone:</label>
        <input
          type="text"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
          required
          disabled={isSubmitting}
          style={inputStyle}
        />
        <label>Message:</label>
        <textarea
          name="message"
          value={formData.message}
          onChange={handleChange}
          required
          disabled={isSubmitting}
          style={textareaStyle}
        />
        <button type="submit" disabled={isSubmitting} style={buttonStyle}>
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default Contact;